import { Action, Reducer } from "redux";
import { AppThunkAction } from "./";
import { MessageData } from "../entities/SystemEntities";

// -----------------------------------------------------------------------------------------------
// state

export interface MessageState {
    data: MessageData;
    lastModifiedTime?: Date;
}

// ------------------------------------------------------------------------------------------------
// actions

const SET_MESSAGE_DATA = 'SET_MESSAGE_DATA';
const CLEAR_MESSAGE_DATA = 'CLEAR_MESSAGE_DATA';

interface SetMessageDataAction {
    type: typeof SET_MESSAGE_DATA;
    data: MessageData;
}

interface ClearMessageDataAction {
    type: typeof CLEAR_MESSAGE_DATA;
}

type KnownAction = SetMessageDataAction | ClearMessageDataAction;

export const actionCreators = {

    showMessageDialog: (title: string, message: string, onAction?: Function): AppThunkAction<KnownAction> => (dispatch, getState) => {
        let data: MessageData = new MessageData();
        data.title = title;
        data.message = message;
        data.onAction = onAction;
        dispatch({
            type: SET_MESSAGE_DATA,
            data: data
        });
    },

    showOkDialog: (title: string, message: string, onAction?: Function): AppThunkAction<KnownAction> => (dispatch, getState) => {
        let data: MessageData = new MessageData();
        data.title = title;
        data.message = message;
        data.type = "Ok";
        data.onAction = onAction;
        dispatch({
            type: SET_MESSAGE_DATA,
            data: data
        });
    },

    showOkCancelDialog: (title: string, message: string, onAction: Function, object?: object): AppThunkAction<KnownAction> => (dispatch, getState) => {
        let data: MessageData = new MessageData();
        data.title = title;
        data.message = message;
        data.type = "OkCancel";
        data.onAction = onAction;
        data.object = object;
        dispatch({
            type: SET_MESSAGE_DATA,
            data: data
        });
    },

    showErrorDialog: (title: string, message: string, onAction?: Function): AppThunkAction<KnownAction> => (dispatch, getState) => {
        let data: MessageData = new MessageData();
        data.title = title;
        data.message = message;
        data.type = "Ok";
        data.style = "error";
        data.onAction = onAction;
        dispatch({
            type: SET_MESSAGE_DATA,
            data: data
        });
    },

    showMessage: (data: MessageData): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: SET_MESSAGE_DATA,
            data: data
        });
    },

    closeModal: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: CLEAR_MESSAGE_DATA
        });
    }
};

// ------------------------------------------------------------------------------------------------
// reducer

export const reducer: Reducer<MessageState> = (state: MessageState | undefined, incomingAction: Action): MessageState => {
    if (state === undefined) {
        return {
            data: null,
            lastModifiedTime: new Date()
        };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SET_MESSAGE_DATA:
            return {
                ...state,
                data: action.data,
                lastModifiedTime: new Date()
            };
        case CLEAR_MESSAGE_DATA:
            return {
                ...state,
                data: null,
                lastModifiedTime: new Date()
            };
        default:
            return state;
    }
};
